import keycloakClient from "@keycloak/keycloak";
import React, { createContext, useMemo, useState } from "react";
import {
  DefaultUserContextType,
  IUserContext,
  UserContextType
} from "./UserContextTypes";

export const UserContext = createContext<UserContextType>(
  DefaultUserContextType
);

export const DEFAULT_USER = {
  language: "en",
  email: "",
  firstName: "",
  lastName: "",
  fullName: ""
};

const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const userFromKeycloak: IUserContext = useMemo(
    () =>
      keycloakClient.tokenParsed
        ? {
            language: keycloakClient.tokenParsed.locale,
            email: keycloakClient.tokenParsed.email,
            firstName: keycloakClient.tokenParsed.given_name,
            lastName: keycloakClient.tokenParsed.family_name,
            fullName: keycloakClient.tokenParsed.name
          }
        : DEFAULT_USER,
    []
  );

  const [currentUser, setCurrentUser] = useState<IUserContext>({
    ...userFromKeycloak
  });

  const saveCurrentUser = (user: IUserContext) => {
    setCurrentUser({ ...user });
  };

  return (
    <UserContext.Provider value={{ currentUser, saveCurrentUser }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
